"use client";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export function PhoneField({
  item,
  value,
  error,
  helperText,
  disabled,
  onFieldChange,
  className,
}) {
  // Handle phone number change
  const handleChange = (phoneValue, country, e, formattedValue) => {
    // Pass the formatted phone value to the parent
    onFieldChange(item.pathToValue, formattedValue, item.type, item);
  };

  return (
    <div className={`phone-input-wrapper ${className || ""}`}>
      <PhoneInput
        country={"us"}
        value={value || ""}
        onChange={handleChange}
        disabled={disabled}
        placeholder={item.placeholder || "Enter phone number"}
        inputClass={`w-full px-3 border rounded-md transition-colors ${
          error
            ? "border-red-500 hover:border-red-500 focus:border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"
        } ${disabled ? "bg-gray-50 cursor-not-allowed" : "bg-white"}`}
        containerClass="w-full"
        buttonClass={`border-r-0 ${
          error ? "border-red-500" : "border-gray-300"
        } ${disabled ? "bg-gray-50" : "bg-white"}`}
        dropdownClass="z-50"
        searchClass="px-3 py-2 border-b border-gray-200"
        inputProps={{
          name: item.pathToValue,
          required: item.required,
          autocomplete: "off",
          "aria-describedby": error ? `${item.pathToValue}-error` : undefined,
        }}
      />

      <style jsx global>{`
        .phone-input-wrapper.h-12 .react-tel-input .form-control {
          height: 3rem !important; /* h-12 equivalent */
          font-size: 1rem !important; /* text-base equivalent */
        }

        .phone-input-wrapper.text-base .react-tel-input .form-control {
          font-size: 1rem !important;
        }

        .phone-input-wrapper .react-tel-input {
          font-family: inherit;
        }

        .phone-input-wrapper .react-tel-input .form-control {
          width: 100% !important;
          height: 40px;
          font-size: 14px;
          border-radius: 6px;
        }

        .phone-input-wrapper .react-tel-input .flag-dropdown {
          border-radius: 6px 0 0 6px;
        }

        .phone-input-wrapper .react-tel-input .selected-flag {
          padding: 0 8px;
        }

        .phone-input-wrapper .react-tel-input .country-list {
          border-radius: 6px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        /* Additional responsive overrides for common Tailwind classes */
        .phone-input-wrapper.h-10 .react-tel-input .form-control {
          height: 2.5rem !important;
        }

        .phone-input-wrapper.h-14 .react-tel-input .form-control {
          height: 3.5rem !important;
        }

        .phone-input-wrapper.text-sm .react-tel-input .form-control {
          font-size: 0.875rem !important;
        }

        .phone-input-wrapper.text-lg .react-tel-input .form-control {
          font-size: 1.125rem !important;
        }
      `}</style>
    </div>
  );
}
